// Initial value argument, compatible with useState(), for useTransientState() hook
// ideally we would exclude `function` from T, but that's not possible yet in TypeScript
export type InitialValue<T> = T | (() => T);

export function getInitialValue<T>(initialValue: InitialValue<T>): T {
  return typeof initialValue === "function" ? (initialValue as () => T)() : initialValue;
}
